module.exports = __webpack_public_path__ + "static/media/activity-toggler.20cba16f.svg";